import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {
  useLoadCollaborator,
  useLoadLookupCollaborator,
} from 'features/collaborator/hooks';
import React from 'react';
import {IntegritySectorGrid} from '.';
import {i18n2} from '../../i18n/i18n';
import {
  useAddSector,
  useDeleteSector,
  useLoadSectors,
  useUpdateSector,
} from '../hooks';
import {SectorSchema} from '../model/Sector';
import {LookupProps} from 'components/grid-dx/MasterGrid';

export const lookupActive = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Planta Alberti')},
      {id: 1, name: i18n2._('Planta Santa Cruz')},
      {id: 2, name: i18n2._('Planta Pagola')},
      {id: 3, name: i18n2._('Planta Pilar')},
      {id: 4, name: i18n2._('Cochabamba')},
      {id: 5, name: i18n2._('Casa Central')},
    ],
    key: 'id',
  },
};

const SectorsGrid = () => {
  const loadSectors = useLoadSectors();
  const loadLookupCollaborators = useLoadLookupCollaborator();
  const addSector = useAddSector();
  const updateSector = useUpdateSector();
  const deleteSector = useDeleteSector();
  const loadCollaborators = useLoadCollaborator();
  return (
    <IntegrityRoleGrid
      allowEdit={[Roles.AdminITPS, Roles.AdminQA]}
      schema={SectorSchema()}
      dataSource={loadSectors}
      promiseAdd={addSector}
      promiseEdit={updateSector}
      promiseDelete={deleteSector}
      id={['iD_Sector']}
      exportName="Sector-export"
      remoteLookup={[
        {
          column: 'resp_Employee_Nr',
          keyValue: 'employee_Nr',
          displayValue: 'name',
          dataSource: loadLookupCollaborators,
        },
      ]}
      columnOptions={columnOptions}
      integrityGrid={IntegritySectorGrid}
      integrityId={['ID_Sector']}
      integrityName={'Sector'}>
      <Column caption={i18n2._('#Sector')} dataField="iD_Sector" />
      <Column
        caption={i18n2._('Nombre')}
        dataField="name"
        width={200}
        defaultSortOrder={'asc'}
      />
      <Column
        caption={i18n2._('Colaborador responsable')}
        dataField="resp_Employee_Nr"
        dataType={'string'}>
        <Lookup
          dataSource={loadCollaborators}
          valueExpr="employee_Nr"
          displayExpr="name"
        />
      </Column>
      <Column caption={i18n2._('Activo en')} dataField="active" width={200}>
        <Lookup
          dataSource={lookupActive}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column
        caption={i18n2._('Meta4 Area Id')}
        dataField="meta4AreaId"
        allowEditing={false}
      />
      <Column caption={i18n2._('Gerencia')} dataField="management" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        visible={false}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column
        caption={i18n2._('Actualizado por')}
        visible={false}
        dataField="updatedBy"
      />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

const columnOptions = [
  {
    column: 'iD_Sector',
    allowEdit: false,
    hiddenAdd: true,
    sizeDesktop: 12,
    sizeMobile: 12,
  },
  {
    column: 'name',
    sizeMobile: 12,
    required: true,
    sizeDesktop: 12,
  },
  {
    selectType: 'enum',
    column: 'active',
    sizeMobile: 12,
    sizeDesktop: 3,
    data: [
      {
        key: 0,
        value: i18n2._('Planta Alberti'),
      },
      {
        key: 1,
        value: i18n2._('Planta Santa Cruz'),
      },
      {
        key: 2,
        value: i18n2._('Planta Pagola'),
      },
      {
        key: 3,
        value: i18n2._('Planta Pilar'),
      },
      {
        key: 4,
        value: i18n2._('Cochabamba'),
      },
      {
        key: 5,
        value: i18n2._('Casa Central'),
      },
    ],
  },
  {
    column: 'management',
    sizeMobile: 12,
    sizeDesktop: 3,
    required: true,
  },
  {
    column: 'meta4AreaId',
    hiddenAdd: true,
    hiddenEdit: true,
    allowEdit: false,
    sizeMobile: 12,
    sizeDesktop: 12,
  },
];

export default SectorsGrid;
